import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  Modal,
  TouchableWithoutFeedback,
  ActivityIndicator,
} from "react-native";
import Cross from "@assets/svg/CrossIcon";
import Text from "@components/CustomText";
import color from "@constants/color";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { getDeliveryPaymentTxns } from "@services/api";
import { fontSize } from "@utils/styles/fonts";

const PaymentDetailModal = ({ showModal, setShowModal, spoke_name }) => {
  const insets = useSafeAreaInsets();
  const [modalData, setModalData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await getDeliveryPaymentTxns({ spoke_name });
      setModalData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const tileColor = (type) => {
    switch (type) {
      case "SUCCESS":
        return color.plain_green;
      case "FAILED":
        return color.plain_red;
      case "PENDING":
        return color.orange;
      case "TOTAL":
        return color.plain_green;
      default:
        return color.plain_green;
    }
  };
  const ModalTile = ({ item }) => {
    return (
      <View key={item?.type} style={styles.modalTile}>
        <View style={styles.tileLeft}>
          <View>
            <Text variant="caption_2" style={styles.tileText}>
              {item?.text}
            </Text>
            <Text variant="caption_3" style={styles.tileSubtext}>
              {item?.subtext}
            </Text>
          </View>
          {item?.txn_type === "ONLINE" && (
            <View
              style={[styles.tileBadge, { borderColor: tileColor(item?.type) }]}
            >
              <Text
                variant="caption_1"
                style={[
                  styles.tileBadgeText,
                  {
                    color: tileColor(item?.type),
                  },
                ]}
              >
                {item?.type}
              </Text>
            </View>
          )}
        </View>
        <Text
          variant="title_20"
          style={{
            color: tileColor(item?.type),
          }}
        >
          {item?.amount_text}
        </Text>
      </View>
    );
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={showModal}
      animationType="slide"
      transparent
    >
      <TouchableWithoutFeedback
        onPress={() => {
          setShowModal(false);
        }}
      >
        <View style={styles.modalOverlay} />
      </TouchableWithoutFeedback>
      <View style={styles.modalContent}>
        <View style={styles.modalCross}>
          <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
            <Cross width={16} height={16} />
          </TouchableWithoutFeedback>
        </View>
        <View
          style={[
            styles.modalInnerContent,
            { paddingBottom: 16 + insets.bottom },
          ]}
        >
          <Text variant="title_20" style={styles.modalTitle}>
            पेमेंट डिटेल्स
          </Text>
          {loading ? (
            <View style={{ flex: 1, justifyContent: "center" }}>
              <ActivityIndicator size="large" color={color.primary} />
            </View>
          ) : (
            <View>
              {modalData?.transactions?.map((item, index) => (
                <ModalTile item={item} />
              ))}
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

export default PaymentDetailModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },
  modalContent: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: "#fff",
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
  modalInnerContent: {
    padding: 16,
    minHeight: 250,
  },
  modalTitle: {
    marginBottom: 12,
  },
  modalTile: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 8,
  },
  tileLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  tileText: {
    color: color.mediumBlack,
  },
  tileSubtext: {
    color: color.mediumBlacklightBlack,
  },
  tileBadge: {
    borderRadius: 30,
    borderWidth: 1,
    marginLeft: 10,
    paddingHorizontal: 8,
  },
  tileBadgeText: {
    fontSize: fontSize._2xs,
    lineHeight: 16,
  },
});
